import { RouteEnumV2 } from '@/constants/enums/RouteEnumV2';
import auth from '@/middleware/auth';
import paid from '@/middleware/paid';
import { type RouteRecordRaw } from 'vue-router';

/**
 * v2 共用頁面路由
 */
export const newV2Funday: RouteRecordRaw[] = [
  {
    /**
     * v2 - 行事曆
     */
    path: '/v2-calendar',
    name: RouteEnumV2.CalendarV2,
    component: () => import('@/views/v2Funday/V2CalendarView.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - 課表
     */
    path: '/v2-schedule',
    name: RouteEnumV2.ScheduleV2,
    component: () => import('@/views/v2Funday/V2ScheduleView.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - 課程紀錄
     */
    path: '/v2-course-record',
    name: RouteEnumV2.CourseRecordV2,
    component: () => import('@/views/v2Funday/v2CourseRecord/index.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - 我的收錄
     */
    path: '/v2-collection',
    name: RouteEnumV2.CollectionV2,
    component: () => import('@/views/v2Funday/V2CollectionView.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - TOEIC Test
     */
    path: '/v2-toeic',
    name: RouteEnumV2.ToeicV2,
    component: () => import('@/views/v2Funday/v2Toeic/index.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - TOEIC Certificate
     */
    path: '/v2-toeic-certificate',
    name: RouteEnumV2.ToeicCertificateV2,
    component: () => import('@/views/v2Funday/v2Toeic/ToeicCertificate.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - TOEIC Exam
     */
    path: '/v2-toeic-exam',
    name: RouteEnumV2.ToeicExamV2,
    component: () => import('@/views/v2Funday/v2Toeic/ToeicExamPage.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - TOEIC Record
     */
    path: '/v2-toeic-record',
    name: RouteEnumV2.ToeicRecordV2,
    component: () => import('@/views/v2Funday/v2Toeic/ToeicRecordPage.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  },
  {
    /**
     * v2 - 直播列表
     */
    path: '/v2-live',
    name: RouteEnumV2.LiveV2,
    component: () => import('@/views/v2Funday/V2LiveView.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth, paid]
    }
  },
  {
    /**
     * v2 - 直播間
     */
    path: '/v2-live/:channelName',
    name: RouteEnumV2.LiveRoomV2,
    component: () => import('@/views/v2Funday/V2LiveRoomView.vue'),
    meta: {
      layout: 'NoLayout',
      version: 'V2',
      middleware: [auth, paid]
    }
  },
  {
    /**
     * v2 - 顧問諮詢室
     */
    path: '/v2-consult',
    name: RouteEnumV2.ConsultV2,
    component: () => import('@/views/v2Funday/v2Consult/index.vue'),
    meta: {
      layout: 'NewV2Layout',
      version: 'V2',
      middleware: [auth]
    }
  }
];
